import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Don't forget to update CONNECT_ROUTES_SET in @jira/platform__common-constants/src/spa-routes
export const servicedeskConnectProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-connect-project',
	path: '/jira/servicedesk/projects/:projectKey',
	query: ['selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'],
	exact: true,
};
